export default __webpack_public_path__ + "static/media/pauseButton.35bfc387.svg";